import { usePostRedirectUrl } from 'builder/features/futureLearn/hooks/useGetRedirectUrl'

type UpskillActions = {
  handleClickCourse: (cmsgid: string) => Promise<void>
  handleExploreCourses: () => void
}

export const useUpskillActions = (): UpskillActions => {
  const { mutateAndRedirect } = usePostRedirectUrl()

  const redirectToFutureLearn = async (cmsgid?: string) => {
    mutateAndRedirect({ cmsgid })
  }

  const handleClickCourse = async (cmsgid: string) => {
    await redirectToFutureLearn(cmsgid)
  }

  const handleExploreCourses = async () => {
    await redirectToFutureLearn()
  }

  return { handleClickCourse, handleExploreCourses }
}
